import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            热度榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            51黑料吃瓜入口当前最热内容排行榜
          </p>
        </div>
        <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-4 md:px-6 py-4 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
              } hover:bg-primary-50/30 transition-colors cursor-pointer`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-heading flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-white'
                    : item.rank === 2
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-accent-400 text-background-50'
                        : 'bg-secondary-200 text-secondary-700'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm text-foreground-800 line-clamp-1">{item.title}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.hot}热度</span>
                <span
                  className={`text-xs ${
                    item.trend === 'up'
                      ? 'text-primary-500'
                      : item.trend === 'new'
                        ? 'text-accent-500'
                        : 'text-foreground-400'
                  }`}
                >
                  {item.trend === 'up' ? '↑' : item.trend === 'new' ? 'NEW' : '→'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}